import { AuthModel } from './auth.model';
import { AddressModel } from './address.model';
import { SocialNetworksModel } from './social-networks.model';

export class ListwidJson {
  emp_codi:string;
  json:JSON;
  wid_desc:string;
}
export class UserModel extends AuthModel {
  doubleauthentication:string;
  id: number;
  username: string;
  accountCode: string;
  displayName: string;
  roleCode: string;
  selectedCompany: Company;
  password: string;
  fullname: string;
  email: string;
  pic: string;
  usu_foto: string;
  roles: number[];
  occupation: string;
  companyName: string;
  phone: string;
  address?: AddressModel;
  socialNetworks?: SocialNetworksModel;
  // personal information
  firstname: string;
  lastname: string;
  website: string;
  // account information
  language: string;
  timeZone: string;
  communication: {
    email: boolean,
    sms: boolean,
    phone: boolean
  };
  // email settings
  emailSettings: {
    emailNotification: boolean,
    sendCopyToPersonalEmail: boolean,
    activityRelatesEmail: {
      youHaveNewNotifications: boolean,
      youAreSentADirectMessage: boolean,
      someoneAddsYouAsAsAConnection: boolean,
      uponNewOrder: boolean,
      newMembershipApproval: boolean,
      memberRegistration: boolean
    },
  };

  setUser(user: any) {
    this.id = user.id;
    this.username = user.username || '';
    this.password = user.password || '';
    this.fullname = user.fullname || '';
    this.email = user.email || '';
    this.pic = user.pic || './assets/media/users/default.jpg';
    this.roles = user.roles || [];
    this.occupation = user.occupation || '';
    this.companyName = user.companyName || '';
    this.phone = user.phone || '';
    this.address = user.address;
    this.socialNetworks = user.socialNetworks;
  }
}

export class CaptchaData {
  base64: string;
  value: string;
  constructor() {
    this.base64 = null;
    this.value = null;
  }

 

}

export class Program {

  id:string;
  name:string;
}


export class Chartgoogle  {
  type: any;
  title: string;
  data: any;
  columnNames: string[];
  width: any;
  height: any;
  options?: any; 
}

export class  options {
  title?: string;
  pieHole?: number;
  chartArea?: { width?: string; height?: string };
  legend?: { position?: string };
  [key: string]: any;
}

export class datawidget {
  wid_cont: any;
  emp_codi: string;
  aud_usua: any;
  aud_esta: string[];
  aud_ufac: Date;
  wid_fech: Date;
  wid_ssql: any;
  wid_titl: any;
  wid_tiwd: any;
  wid_nomb: any;
  usu_list: string;
}
export class datawidgetUser {
  usu_codi: any;
  usu_nomb: string;

}

export class Company {
  // Código de empresa
  code: string;

  photo: any;
  // Nombre de la empresa
  name: string;
  // Tema asignado a la cuenta
  theme: Theme;

  nit: Theme;
}

export class ValidarLicencia {
  ErrorMensaje: string;
}

export class Theme {
  id: string;
  code: number;
  name:string;
  assets: ThemeAssets = new ThemeAssets();
}

export class ThemeAssets {
  primaryColor:string;
  primaryTextColor :string;
  secundaryColor:string;
  secundaryTextColor :string;
  titleColor:string;
  titleTextColor:string;
  subTitleColor :string;
  labelColor :string;
  gridHeaderColor :string;
  gridHeaderTextColor :string;
  primaryButtonColor :string;
  primaryButtonTextColor :string;
  secundaryButtonColor :string;
  secundaryButtonTextColor :string;
  borderColor:string;
}
export class User {
  displayName!: string;
  email!: string;
  avatar!: string;
  timeZone!: string;
}

